import { render } from "./FormTrainingHeadRegionAnchor.vue?vue&type=template&id=f2211b1e&scoped=true&ts=true"
import script from "./FormTrainingHeadRegionAnchor.vue?vue&type=script&lang=ts"
export * from "./FormTrainingHeadRegionAnchor.vue?vue&type=script&lang=ts"

import "./FormTrainingHeadRegionAnchor.vue?vue&type=style&index=0&id=f2211b1e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2211b1e"]])

export default __exports__